import {
  COUNTRY_AUSTRALIA,
  COUNTRY_AUSTRALIA_CODE,
  COUNTRY_CANADA,
  COUNTRY_CANADA_CODE,
  COUNTRY_US,
  COUNTRY_US_CODE,
  STATES_AUSTRALIA,
  STATES_CANADA,
  STATES_US,
} from "@common/constants/data";
import { SelectItem } from "@mantine/core";

export function isAddressValidated(country: string): boolean {
  return (
    country === COUNTRY_US ||
    country === COUNTRY_US_CODE ||
    country === COUNTRY_CANADA ||
    country === COUNTRY_CANADA_CODE ||
    country === COUNTRY_AUSTRALIA ||
    country === COUNTRY_AUSTRALIA_CODE
  );
}

export function getSelecItemsFromCountry(country: string): SelectItem[] {
  // US
  if (country === COUNTRY_US || country === COUNTRY_US_CODE) {
    return STATES_US;
  }
  // Canada
  else if (country === COUNTRY_CANADA || country === COUNTRY_CANADA_CODE) {
    return STATES_CANADA;
  }
  // Australia
  else if (
    country === COUNTRY_AUSTRALIA ||
    country === COUNTRY_AUSTRALIA_CODE
  ) {
    return STATES_AUSTRALIA;
  }

  return [{ value: "n/a", label: `${country} is not supported` }];
}
